// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;
 
export const BASEURL = `https://api.epixcinemas.com`;
 
// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://images.epixcinemas.com`;
 
export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;
export const EPIX_TOKEN = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjU4ZDJlZTM4LTI4MDctNDQ4My05YzVhLThhZDYxMjI2OGY0MSIsImlhdCI6MTcwMzgzNTMzNn0.3eAPpdCzFTsGuHbgeJFCZknPbWS0WjDD1aSnNy_HRTk`;
export const TOKEN = EPIX_TOKEN;



// WEBPACK FOOTER //
// ./src/config/index.js